import * as R from 'remeda'

import {
  calcFiveSegmentsRatioAndIndicators,
  exists,
  type FiveSegmentCounts,
  type FiveSegmentIndicator,
  toFiveSegmentCounts,
} from '~/utils'

import { type NineSegmentsBrandData } from './buildNineSegmentsBrandsData'

export type FiveSegmentsBrandData = {
  brandId: number
  brandName: string
  brandNumber: number
  counts: FiveSegmentCounts
  ratios: FiveSegmentCounts & Record<FiveSegmentIndicator, number>
}

export type FiveSegmentsBrandsSortValue = {
  ascending: boolean
  columnKey: keyof FiveSegmentsBrandData['ratios']
}

export type FiveSegmentsBrandsDataInput = {
  nineSegmentsBrandsData: ReadonlyArray<NineSegmentsBrandData>
  sampleSize: number
  sortValue: FiveSegmentsBrandsSortValue | null | undefined
}

export const buildFiveSegmentsBrandsData = (
  input: FiveSegmentsBrandsDataInput,
): FiveSegmentsBrandData[] =>
  R.pipe(
    input.nineSegmentsBrandsData,
    R.map((nineSegmentsBrandData): FiveSegmentsBrandData => {
      const fiveSegmentCounts = toFiveSegmentCounts(
        nineSegmentsBrandData.counts,
      )

      return {
        ...nineSegmentsBrandData,
        counts: fiveSegmentCounts,
        ratios: calcFiveSegmentsRatioAndIndicators(
          fiveSegmentCounts,
          input.sampleSize,
        ),
      }
    }),
    R.sortBy((item) =>
      exists(input.sortValue)
        ? item.ratios[input.sortValue.columnKey] *
          (input.sortValue.ascending ? 1 : -1)
        : 0,
    ),
  )
